import { render } from "./MeiArea.vue?vue&type=template&id=a10e040c&scoped=true"
import script from "./MeiArea.vue?vue&type=script&lang=js"
export * from "./MeiArea.vue?vue&type=script&lang=js"

import "./MeiArea.vue?vue&type=style&index=0&id=a10e040c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a10e040c"]])

export default __exports__